import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import UserRepository from "src/repository/Admin/UserRepository";
import { getForbiddenResponseMessage } from "src/service/forbiddenResponseMessage";

export const getUserList = createAsyncThunk('get_user_list', async (params) => {
    try {
        return await new UserRepository().getUserList(params)
    } catch (error) {
        return { users: [], total: 0, message: getForbiddenResponseMessage(error) }
    }
});

export const getUserDetail = createAsyncThunk('get_user_detail', async (userId) => {
    return await new UserRepository().getUserDetail(userId)
});
export const getUserAcctList = createAsyncThunk('get_user_acct_list', async (userId) => {
    try {
        return await new UserRepository().getUserAcctList(userId)
    } catch (error) {
        return { records: [], message: getForbiddenResponseMessage(error) }
    }
});
export const getUserSearchAcctList = createAsyncThunk('get_user_search_acct_list', async (params) => {
    try {
        return await new UserRepository().getUserSearchAcctList(params)
    } catch (error) {
        return { records: [], message: getForbiddenResponseMessage(error) }
    }
});

export const getSearchSponsorAccounts = createAsyncThunk('get_search_sponsor_accounts_list', async (params) => {
    try {
        return await new UserRepository().searchSponsorAccounts(params)
    } catch (error) {
        return { data: { data: { accountList: [] } }, message: getForbiddenResponseMessage(error) }
    }
});

const slice = createSlice({
    name: "User",
    initialState: {
        totalRecords: 0,
        filteredRecords: 0,
        userListMessage: '',
        userList: [],
        userDetail: {},
        userAcctListMessage: '',
        userAcctList: [],
        userSearchAcctListMessage: '',
        userSearchAcctList: [],
        USER_SEARCH_ACCT_POPUP_STATUS: false,
        roleSelectionPopUpStatus: false,
        selectedRoles: '',
        selectedRoleIndex: null,
        searchSponsorAccountsMessage: '',
        searchSponsorAccounts: [],
        selectedUserSponsorAccounts: {},
        selectedAccounts: []
    },
    reducers: {
        setUserList: {
            reducer: (state, action) => {
                state.userList = action.payload;
                state.userListMessage = '';
                return state;
            },
        },
        setUserListMessage: {
            reducer: (state, action) => {
                state.userListMessage = action.payload;
                return state;
            },
        },
        setUserAcctList: {
            reducer: (state, action) => {
                state.userAcctList = action.payload;
                state.userAcctListMessage = '';
                return state;
            },
        },
        setUserAcctListMessage: {
            reducer: (state, action) => {
                state.userAcctListMessage = action.payload;
                return state;
            },
        },
        setUserSearchAcctList: {
            reducer: (state, action) => {
                state.userSearchAcctList = action.payload;
                state.userSearchAcctListMessage = '';
                return state;
            },
        },
        setUserSearchAcctPopupStatus: {
            reducer: (state, action) => {
                state.USER_SEARCH_ACCT_POPUP_STATUS = action.payload;
                return state;
            },
        },
        setRoleSelectionPopUpStatus: {
            reducer: (state, action) => {
                state.roleSelectionPopUpStatus = action.payload;
                return state;
            },
        },
        setSelectedRoles: {
            reducer: (state, action) => {
                state.selectedRoles = action.payload;
                return state;
            },
        },
        setSelectedRoleIndex: {
            reducer: (state, action) => {
                state.selectedRoleIndex = action.payload;
                return state;
            },
        },
        setSelectedUserSponsorAccounts: {
            reducer: (state, action) => {
                state.selectedUserSponsorAccounts = action.payload;
                return state;
            },
        },
        setSearchSponsorAccounts: {
            reducer: (state, action) => {
                state.searchSponsorAccounts = action.payload;
                state.searchSponsorAccountsMessage = '';
                return state;
            },
        },
        setSelectedAccounts: {
            reducer: (state, action) => {
                state.selectedAccounts = action.payload;
                return state;
            },
        },
    },
    extraReducers: {
        [getUserList.fulfilled]: (state, action) => {
            state.userList = action.payload.users;
            state.totalRecords = action.payload.total;
            state.filteredRecords = action.payload.users?.length;
            state.userListMessage = action.payload.message || '';
        },
        [getUserDetail.fulfilled]: (state, { payload }) => {
            state.userDetail = payload
        },
        [getUserAcctList.fulfilled]: (state, { payload }) => {
            state.userAcctList = payload.records;
            state.totalUserRecords = payload.records?.length;
            state.filteredUserRecords = payload.records?.length;
            state.userAcctListMessage = payload.message || '';
        },
        [getUserSearchAcctList.fulfilled]: (state, { payload }) => {
            state.userSearchAcctList = payload.records;
            state.userSearchAcctListMessage = payload.message || '';
        },
        [getSearchSponsorAccounts.fulfilled]: (state, action) => {
            state.searchSponsorAccounts = action.payload.data?.data?.accountList;
            state.searchSponsorAccountsMessage = action.payload.message || '';
        },
    },
});



export let { setUserList, setUserListMessage, setUserSearchAcctList, setUserSearchAcctPopupStatus, setRoleSelectionPopUpStatus, setSelectedRoles, setSelectedRoleIndex, setUserAcctList, setUserAcctListMessage, setSelectedUserSponsorAccounts, setSearchSponsorAccounts, setSelectedAccounts } = slice.actions;

export default slice.reducer;
